import { getModeledFactions as getStoreItems } from 'selectors'
import { useSelector } from 'react-redux'
import { factions as fixtures } from '@fedsim/imports'

import { mapImported } from '../helpers'

export function useFactions () {
  const imported: any[] = useSelector(getStoreItems)
  const mapped = mapImported(fixtures, imported)
  const notImported = mapped?.filter(item => item.imported === false)

  return { mapped, fixtures, notImported, imported }
}
